import React, { useEffect } from "react";
import { Box, SxProps, Theme } from "@mui/material";
import { useIsMobile } from "../hooks";
interface Props {
  children?: React.ReactNode;
  fullscreen?: boolean;
}

const PageContentStyle: Record<string, SxProps<Theme>> = {
  container: {
    display: "flex",
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    padding: "20px",
    flexDirection: "column",
  },
  containerMobile: {
    display: "flex",
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    padding: "20px",
    flexDirection: "column",
  },
  fullscreen: {
    paddingLeft: "0px",
    paddingRight: "0px",
  },
};

const PageContent: React.FC<Props> = ({ children, fullscreen }) => {
  const { isMobile } = useIsMobile();

  return (
    <Box
      sx={[
        isMobile
          ? PageContentStyle.containerMobile
          : PageContentStyle.container,
        fullscreen ? PageContentStyle.fullscreen : {},
      ].flat(2)}
    >
      {children}
    </Box>
  );
};

export default PageContent;
